import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

export default async function getTauxTva(listeTauxTva) {
  await store.dispatch('parametres/loadParametres', [PARAMETRES_KEYS.regimeTva]);
  const listeTauxTvaParam = store.getters['parametres/parametre'](PARAMETRES_KEYS.regimeTva);
  [...new Set(listeTauxTva)].forEach((tauxTva) => {
    if (tauxTva === undefined) return;
    let newTauxTva = 0;
    if (tauxTva.includes('%')) newTauxTva = tauxTva.replace(',', '.').replace('%', '');
    newTauxTva = parseFloat(newTauxTva);
    const isInParam = listeTauxTvaParam.find((f) => f.tauxTva === newTauxTva);
    const errors = [];
    if (!isInParam) {
      errors.push({
        message: 'importDonne.dataNotExist',
        parametres: { data: tauxTva },
      });
    }
    if (errors.length > 0) throw errors;
  });
}
